declare namespace $ {

	type $mol_image__uri_bog_bzrl_app_profile_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_minor__click_bog_bzrl_app_profile_2 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_bzrl_app_profile_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_bzrl_app_profile_avatar__profile_bog_bzrl_app_profile_4 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['profile_entity'] >
		,
		ReturnType< $bog_bzrl_app_profile_avatar['profile'] >
	>
	type $bog_theme_toggle__theme_auto_bog_bzrl_app_profile_5 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['theme_auto'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $mol_view__sub_bog_bzrl_app_profile_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string_button__value_bog_bzrl_app_profile_7 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_bzrl_app_profile_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_dimmer__haystack_bog_bzrl_app_profile_9 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['profile_id'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_view__sub_bog_bzrl_app_profile_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_bzrl_app_profile_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_card__Content_bog_bzrl_app_profile_12 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['Menu'] >
		,
		ReturnType< $mol_card['Content'] >
	>
	type $mol_pop_over__Anchor_bog_bzrl_app_profile_13 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_profile['Button'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_bog_bzrl_app_profile_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	export class $bog_bzrl_app_profile extends $mol_view {
		avatar_uri( ): string
		Avatar( ): $mol_image
		Button( ): $mol_button_minor
		Avatar_large( ): $bog_bzrl_app_profile_avatar
		Theme_toggle( ): $bog_theme_toggle
		Header_top( ): $mol_view
		name( next?: string ): string
		Name( ): $mol_string_button
		profile_id( ): string
		Id( ): $mol_dimmer
		Header( ): $mol_view
		Menu( ): $mol_list
		Card( ): $mol_card
		Panel( ): $mol_pop_over
		opened( next?: boolean ): boolean
		toggle( next?: any ): any
		theme_auto( ): $bog_theme_auto
		profile_entity( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=profile.view.tree.d.ts.map